import { CalendarViewMonthSharp } from "@mui/icons-material";

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function convertTextToBytes(sizeString) {
  if (!sizeString || typeof sizeString !== 'string') {
    return 0; // Or throw an error, depending on desired behavior
  }

  const trimmedString = sizeString.trim();
  const parts = trimmedString.match(/^(\d+(\.\d+)?)\s*(B|KB|MB|GB|TB|PB|EB|ZB|YB)$/i);

  if (!parts) {
    console.warn(`Invalid size string format: "${sizeString}"`);
    return 0; // Or throw an error
  }

  const value = parseFloat(parts[1]);
  const unit = parts[3].toUpperCase();

  const unitsMap = {
    'B': 1,
    'KB': 1024,
    'MB': 1024 ** 2,
    'GB': 1024 ** 3,
    'TB': 1024 ** 4,
    'PB': 1024 ** 5,
    'EB': 1024 ** 6,
    'ZB': 1024 ** 7,
    'YB': 1024 ** 8,
  };

  if (!unitsMap[unit]) {
    console.warn(`Unknown unit: "${unit}" in "${sizeString}"`);
    return 0; // Or throw an error
  }

  return value * unitsMap[unit];
}

export function getAreas(claim){

  const areaMap = {
   "UISS-QM-Administrative-Support-Units-Spokane":"Administrative Support Units | Spokane",
   "UISS-QM-Athletics-Pullman":"Athletics | Pullman",
   "UISS-QM-Business-and-Financial-Services":"Finance and Business Services",
   "UISS-QM-Carson-College-of-Business-Pullman":"Carson College of Business | Pullman",
   "UISS-QM-CAS-CAHNRS-School-of-the-Environment":"CAS & CAHNRS - School of the Environment",
"UISS-QM-CAS-VCEA-Institute-of-Materials-Research":"CAS & VCEA - Institute of Materials Research",
"UISS-QM-Central":"Central",
"UISS-QM-College-of-Agricultural-Human-and-Natural-Resource-Sciences-Pullman":"College of Agricultural, Human, and Natural Resource Sciences | Pullman",
"UISS-QM-College-of-Arts-and-Sciences-Pullman":"College of Arts and Sciences | Pullman",
"UISS-QM-College-of-Education-Sport-and-Human-Sciences-Pullman":"College of Education, Sport, and Human Sciences | Pullman",
"UISS-QM-College-of-Nursing-Spokane":"College of Nursing | Spokane",
"UISS-QM-College-of-Pharmacy-and-Pharmaceutical-Sciences-Spokane":"College of Pharmacy and Pharmaceutical Sciences | Spokane",
"UISS-QM-College-of-Veterinary-Medicine-Pullman":"College of Veterinary Medicine | Pullman",
"UISS-QM-Elson-S-Floyd-College-of-Medicine-Spokane":"Elson S. Floyd College of Medicine | Spokane",
"UISS-QM-Enrollment-Pullman":"Enrollment | Pullman",
"UISS-QM-Everett":"Everett",
"UISS-QM-Facilities":"Facilities",
"UISS-QM-Finance-Operations":"Finance Operations",
"UISS-QM-Global-Campus":"Global Campus",
"UISS-QM-Graduate-School-Pullman":"Graduate School | Pullman",
"UISS-QM-Human-Resource-Services":"Human Resource Services",
"UISS-QM-Information-Technology":"Information Technology",
"UISS-QM-International-Programs-Pullman":"International Programs | Pullman",
"UISS-QM-Libraries-Pullman":"Libraries | Pullman",
"UISS-QM-Murrow-College-of-Communication-Pullman":"Murrow College of Communication | Pullman",
"UISS-QM-Not-Classified":"Not Classified",
"UISS-QM-Office-External-Affairs-and-Government-Relations-Pullman":"Office of External Affairs and Government Relations | Pullman",
"UISS-QM-Office-of-Research-Pullman":"Office of Research | Pullman",
"UISS-QM-Presidential-Units-Pullman":"Presidential Units | Pullman",
"UISS-QM-Provosts-Office-Pullman":"Provosts Office | Pullman",
"UISS-QM-Public-Safety-and-Business-Operations":"Public Safety and Business Operations",
"UISS-QM-Student-Affairs-Pullman":"Student Affairs | Pullman",
"UISS-QM-Tri-Cities":"Tri-Cities",
"UISS-QM-University-Development-Pullman":"University Development | Pullman",
"UISS-QM-University-Marketing-and-Communications-Pullman":"University Marketing and Communications | Pullman",
"UISS-QM-Unknown":"Unknown",
"UISS-QM-Vancouver":"Vancouver",
"UISS-QM-Voiland-College-of-Engineering-and-Architecture-Pullman":"Voiland College of Engineering and Architecture | Pullman",
    "UISS-QM-Vancouver-Students": "Vancouver (Student)"

  }

  const areas = []

  if(claim.includes("UISS-QM-Administrator")){
    for(const [key, val] of Object.entries(areaMap)){
      areas.push(val);
    }
  }else{
    claim.forEach(area => {
      if(areaMap[area]){
        areas.push(areaMap[area]);
      }
    });
  }

  return areas;

}